var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grid" },
    [
      _c("header", { staticClass: "grid-header" }, [
        _c(
          "h1",
          [
            _c("router-link", { attrs: { to: { name: "home" } } }, [
              _vm._v("Umberto Imperial"),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "nav",
          [
            _c("router-link", { attrs: { to: { name: "contact" } } }, [
              _vm._v("Контакты"),
            ]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: { name: "about" } } }, [
              _vm._v("О нас"),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("router-view", { staticClass: "grid-main" }),
      _vm._v(" "),
      _c("footer", { staticClass: "grid-footer" }, [
        _vm._v("\n        Магазин одежды Umberto Imperial\n    "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }